import { createApiSelectors } from 'reacticoon/selector'
import { formatUserMe } from 'modules/userMe/format'

export const loginMfaSelectors = createApiSelectors('App::LoginMfaModule', formatUserMe)
